import Loader from '@/components/Loader';
import { useUser } from '@lore/auth';
import React, { useState } from 'react';
import { PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';
import useUserTags from '@/hooks/useUserTags';
import Expertises from '../../setup/skills/Expertises';

export default function EditableSkills() {
  const currentUser = useUser();
  const [isEditing, setIsEditing] = useState(false);
  const expertiseTypes = useTags(TagTypes.ExpertiseType);
  const userExpertises = useUserTags(currentUser, TagTypes.Expertise);

  if (!currentUser || expertiseTypes.state === 'FETCHING' || userExpertises.state === 'FETCHING') {
    return <Loader />;
  }

  return (
    <div>
      <div className="mb-2 flex items-center space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">What skills and experience can you share?</h4>
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          onClick={() => setIsEditing(!isEditing)}
          aria-label={isEditing ? 'Close edit skills' : 'Edit skills'}
        >
          {isEditing ? (
            <XMarkIcon className="size-5" />
          ) : (
            <PencilSquareIcon className="size-5" />
          )}
        </button>
      </div>
      {isEditing ? (
        <div className="mt-4">
          <Expertises
            user={currentUser}
            expertiseTypes={expertiseTypes}
            userExpertises={userExpertises}
          />
        </div>
      ) : (
        <div className="space-y-2 text-base text-cs-gray-500">
          {userExpertises.data.length > 0 ? (
            userExpertises.data.map((ue) => (
              <div key={ue.id}>
                <div>{ue.data.name}</div>
                {ue._tagNode.data.description && (
                  <div className="text-xs pl-4">{ue._tagNode.data.description}</div>
                )}
              </div>
            ))
          ) : (
            <p className="italic text-cs-gray-400">No skills selected.</p>
          )}
        </div>
      )}
    </div>
  );
}
